import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from "@angular/router";
import {Injectable} from "@angular/core";
import {UserUtil} from "../utils/UserUtil";
import {LoanApplicationService} from "../service/loan-application.service";
import {UserInteractor} from "../interactors/user.interactor";
import {isEmpty} from 'lodash';
import {ConfigService} from "../service/config.service";

@Injectable()
export class OnlyUsersWithoutLoanApplicationGuard implements CanActivate {
    constructor(private userUtil: UserUtil,
                private router: Router,
                private loanApplicationService: LoanApplicationService,
                private userInteractor: UserInteractor,
                private configService: ConfigService) {
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        if (!this.userUtil.isUserLoggedIn())
            return true;

        const userId = await this.userInteractor.getUserId();
        const loanApplications = await this.loanApplicationService.getLoanApplicationsByUserId(userId);

        if (isEmpty(loanApplications))
            return true;

        return this.router.createUrlTree(['/borrow/dashboard/applications']);
    }
}
